import { t } from 'i18next';
import type { TradingPhotoCardType } from '../types/TradingPhotoCardType';
import TradingPhotoCard from './TradingPhotoCard';

interface TradingPhotoCardsListProps {
  tradingPhotoCards: TradingPhotoCardType[];
  activeTab: number;
}

const TradingPhotoCardsList = ({ tradingPhotoCards, activeTab }: TradingPhotoCardsListProps) => {
  return (
    <>
      {tradingPhotoCards.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-[11px] gap-y-[28px] justify-items-center">
          {tradingPhotoCards.map((photoCard) => (
            <TradingPhotoCard key={photoCard.tradingPhotoCardId} photoCard={photoCard} />
          ))}
        </div>
      ) : (
        <div className="h-full flex flex-col items-center justify-center mt-[110px]">
          <p className="w-[50px] h-[75px] text-[50px]">😓</p>
          <p className="mt-[8px] text-[14px] font-medium text-text-main-lv4">
            {activeTab === 0
              ? t('TradingUserProfilePage.saleEmptyCards')
              : t('TradingUserProfilePage.exchangeEmptyCards')}
          </p>
        </div>
      )}
    </>
  );
};

export default TradingPhotoCardsList;
